import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hmpg',
  templateUrl: './hmpg.component.html',
  styleUrls: ['./hmpg.component.css']
})
export class HmpgComponent implements OnInit {

  constructor() { }

  flag:boolean = false;
  sliderPics = ['assets/image/hmpg_1.jpg','assets/image/hmpg_2.jpg'];
  sliderPicCur = this.sliderPics[0];
  sliderPicCurIdx = 0;
  sliderPicPoper;
  timer = null;

  ngOnInit() {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
        this.showMarquee();
    }, 3000);
  }

  showMarquee() {
    this.flag = true;
    setTimeout (() => {
        this.sliderPics.push(this.sliderPics[0]);
        this.sliderPics.shift();
        this.sliderPicCur = this.sliderPics[0];
        this.flag = false;
    }, 500);
 }

 onSelectWsiperLeft(): void {
    this.sliderPics.push(this.sliderPics[0]);
    this.sliderPics.shift();
    this.sliderPicCur = this.sliderPics[0];
    this.flag = false;
  }

  onSelectWsiperRight(): void {
    this.sliderPicPoper = this.sliderPics.pop();
    this.sliderPics.unshift(this.sliderPicPoper);
    this.sliderPicCur = this.sliderPics[0];
    this.flag = false;
  }


}

